import { render, staticRenderFns } from "./BenefitContainer.vue?vue&type=template&id=2d20963a&"
import script from "./BenefitContainer.vue?vue&type=script&lang=js&"
export * from "./BenefitContainer.vue?vue&type=script&lang=js&"
import style0 from "./BenefitContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports